export enum AssetsType {
  Music = 1,
  Video = 2,
  Art = 3,
  Album = 4,
}